var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"d-flex align-center px-3",style:({
    color: _vm.isActive ? '#3461FF' : '#222222',
    minWidth: '76px',
  }),attrs:{"type":"button"}},'button',_vm.attrs,false),_vm.on),[_c('v-icon',{staticClass:"mr-1",attrs:{"size":"18","color":_vm.isActive ? '#3461FF' : '#222222'}},[_vm._v(" mdi-filter ")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }